import React from "react";
import "./Page404.css";
import { Link } from "react-router-dom";
import { BiHomeSmile } from "react-icons/bi";
import SubHeader from "../userDashboard/subHeader";

const Page404 = () => {
  return (
    <div className="error-container">
      <SubHeader />
      <div className="error-content">
        <div className="error-card">
          <div className="maintenance-badge">SCHEDULED MAINTENANCE</div>

          <h2 className="error-title">
            We're currently performing scheduled upgrades
          </h2>

          <p className="error-subtitle">We apologize for the inconvenience</p>

          {/* Added Download Section */}
          <div className="download-section">
            <p className="download-text">
              In the meantime, download the Vitel Wireless app on:
            </p>
            <div className="store-buttons">
              <a
                href="https://play.google.com/store/search?q=vitel+command&c=apps&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className="store-button google-play"
              >
                <img
                  src="https://www.citypng.com/public/uploads/preview/hd-google-play-playstore-logo-symbol-png-701751694777134cuw3jc7voo.png"
                  alt=""
                />
                Google Play
              </a>
              <a
                href="https://apps.apple.com/ng/app/vitel-wireless-command/id6756784906"
                target="_blank"
                rel="noopener noreferrer"
                className="store-button apple-store"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Apple_Store_logo.svg/2048px-Apple_Store_logo.svg.png"
                  alt=""
                />
                Apple Store
              </a>
            </div>
          </div>

          <p className="error-message">
            Sincere apologies. command.vitelwireless.com is currently undergoing
            scheduled maintenance and upgrades to serve you better. We
            appreciate your patience and understanding.
          </p>

          <div className="error-actions">
            <button
              className="home-button"
              onClick={() => window.location.reload()}
              style={{
                background: "linear-gradient(135deg, #4299e1 0%, #3182ce 100%)",
              }}
            >
              Refresh Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page404;
